import React from "react";
import { BETA_SITE_URL } from "./BetaAnnouncementBar";
import "./BetaSwitcherButton.scss";

/**
 * Persistent "Switch to Version 3" pill rendered in the header (desktop topbar
 * and mobile header). The announcement bar above is dismissable for the
 * session — this switcher stays visible always so trainers can jump to
 * Version 3 at any time.
 *
 * @param {boolean} compact - tighter spacing for the mobile header.
 */
const BetaSwitcherButton = ({ compact = false }) => {
  const className = compact
    ? "beta-switcher-button beta-switcher-button--compact"
    : "beta-switcher-button";

  return (
    <a
      href={BETA_SITE_URL}
      className={className}
      aria-label="Switch to Version 3"
    >
      <svg
        className="beta-switcher-button__icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="17 1 21 5 17 9" />
        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
        <polyline points="7 23 3 19 7 15" />
        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
      </svg>
      <span className="beta-switcher-button__label">Switch to Version 3</span>
    </a>
  );
};

export default BetaSwitcherButton;
